import { render, staticRenderFns } from "./Ops.vue?vue&type=template&id=601e826f&scoped=true"
import script from "./Ops.vue?vue&type=script&lang=js"
export * from "./Ops.vue?vue&type=script&lang=js"
import style0 from "./Ops.vue?vue&type=style&index=0&id=601e826f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601e826f",
  null
  
)

export default component.exports